import superagent from 'superagent';
import superagentAbsolute from 'superagent-absolute';
import globals from './globals';

if(typeof globals.baseUrl !== 'undefined') {
    const agent = superagent.agent()
        .set('accept', 'json')
        .timeout({
            //response: 5000,  // Wait 5 seconds for the server to start sending,
            deadline: 60000, // but allow 1 minute for the file to finish loading.
        })
        .withCredentials(); // The .withCredentials() method enables the ability to send cookies from the origin, however only when Access-Control-Allow-Origin is not a wildcard ("*"), and Access-Control-Allow-Credentials is "true".
    window.request = superagentAbsolute(agent)(globals.baseUrl);
} else {
    const agent = superagent.agent()
        .set('accept', 'json')
        .timeout({
            //response: 5000,  // Wait 5 seconds for the server to start sending,
            deadline: 60000, // but allow 1 minute for the file to finish loading.
        });
    window.request = agent;
}

const requestDefaults = {
    'Socket-ID': '0',
    'Accept': 'application/json',
};
